import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// src/combineKeys.ts
import { Observable } from "rxjs";
var combineKeys = function combineKeys(keys$, getInner$) {
  return new Observable(function (observer) {
    var innerSubscriptions = /* @__PURE__ */new Map();
    var changes = /* @__PURE__ */new Set();
    var currentValue = /* @__PURE__ */new Map();
    var updatingSource = false;
    var isPristine = true;
    var next = function next() {
      if (!updatingSource) {
        var result = Object.assign(currentValue, {
          changes: changes
        });
        changes = /* @__PURE__ */new Set();
        isPristine = false;
        observer.next(result);
      }
    };
    var subscription = keys$.subscribe(function (nextKeysArr) {
      updatingSource = true;
      var keys = new Set(inputIsKeyChanges(nextKeysArr) ? nextKeysArr.keys : nextKeysArr);
      if (inputIsKeyChanges(nextKeysArr)) {
        if (nextKeysArr.type === "remove") {
          keys.forEach(function (key) {
            var sub = innerSubscriptions.get(key);
            if (!sub) return;
            sub.unsubscribe();
            innerSubscriptions.delete(key);
            if (currentValue.has(key)) {
              changes.add(key);
              currentValue.delete(key);
            }
          });
          keys.clear();
        }
      } else {
        innerSubscriptions.forEach(function (sub, key) {
          if (!keys.has(key)) {
            sub.unsubscribe();
            innerSubscriptions.delete(key);
            if (currentValue.has(key)) {
              changes.add(key);
              currentValue.delete(key);
            }
          } else {
            keys.delete(key);
          }
        });
      }
      keys.forEach(function (key) {
        innerSubscriptions.set(key, getInner$(key).subscribe(function (x) {
          if (!currentValue.has(key) || currentValue.get(key) !== x) {
            changes.add(key);
            currentValue.set(key, x);
            next();
          }
        }, function (e) {
          observer.error(e);
        }));
      });
      updatingSource = false;
      if (changes.size || isPristine && !keys.size) next();
    }, function (e) {
      observer.error(e);
    }, function () {
      observer.complete();
    });
    return function () {
      subscription.unsubscribe();
      innerSubscriptions.forEach(function (sub) {
        sub.unsubscribe();
      });
    };
  });
};
function inputIsKeyChanges(input) {
  return "type" in input && "keys" in input;
}

// src/createSignal.ts
import { identity, Subject } from "rxjs";
function createSignal() {
  var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : identity;
  var subject = new Subject();
  return [subject.asObservable(), function () {
    return subject.next(mapper.apply(void 0, arguments));
  }];
}

// src/createKeyedSignal.ts
import { Observable as Observable3 } from "rxjs";
function createKeyedSignal(keySelector, mapper) {
  var observersMap = /* @__PURE__ */new Map();
  return [function (key) {
    var res = new Observable3(function (observer) {
      if (!observersMap.has(key)) {
        observersMap.set(key, /* @__PURE__ */new Set());
      }
      var set = observersMap.get(key);
      set.add(observer);
      return function () {
        set.delete(observer);
        if (set.size === 0) {
          observersMap.delete(key);
        }
      };
    });
    res.key = key;
    return res;
  }, function () {
    var _a;
    var payload = mapper ? mapper.apply(void 0, arguments) : arguments.length === 2 ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 0 ? undefined : arguments[0];
    var key = keySelector ? keySelector(payload) : arguments.length <= 0 ? undefined : arguments[0];
    (_a = observersMap.get(key)) == null ? void 0 : _a.forEach(function (o) {
      o.next(payload);
    });
  }];
}

// src/mergeWithKey.ts
import { merge, from } from "rxjs";
import { map } from "rxjs/operators";
var mergeWithKey = function mergeWithKey(input) {
  for (var _len = arguments.length, optionalArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    optionalArgs[_key - 1] = arguments[_key];
  }
  return merge.apply(void 0, _toConsumableArray(Object.entries(input).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      type = _ref2[0],
      stream = _ref2[1];
    return from(stream).pipe(map(function (payload) {
      return {
        type: type,
        payload: payload
      };
    }));
  }).concat(optionalArgs)));
};

// src/partitionByKey.ts
import { shareLatest } from "@react-rxjs/core";
import { identity as identity2, noop, Observable as Observable5, Subject as Subject2, Subscription as Subscription2 } from "rxjs";
import { map as map2 } from "rxjs/operators";
function partitionByKey(stream, keySelector, streamSelector) {
  var groupedObservables$ = new Observable5(function (subscriber) {
    var groups = /* @__PURE__ */new Map();
    var sourceCompleted = false;
    var finalize = function finalize(type) {
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        sourceCompleted = true;
        if (groups.size) {
          groups.forEach(function (g) {
            var _g$source;
            return (_g$source = g.source)[type].apply(_g$source, args);
          });
        } else {
          subscriber[type].apply(subscriber, args);
        }
      };
    };
    var sub2 = stream.subscribe(function (x) {
      var key = keySelector(x);
      if (groups.has(key)) return groups.get(key).source.next(x);
      var pendingFirstAdd = true;
      var emitFirstAdd = function emitFirstAdd() {
        if (pendingFirstAdd) {
          pendingFirstAdd = false;
          subscriber.next({
            groups: groups,
            changes: {
              type: "add",
              keys: [key]
            }
          });
        }
      };
      var subject = new Subject2();
      var pendingFirstVal = true;
      var emitFirstValue = function emitFirstValue() {
        if (pendingFirstVal) {
          pendingFirstVal = false;
          subject.next(x);
        }
      };
      var shared$ = shareLatest()((streamSelector || identity2)(subject, key));
      var res = new Observable5(function (observer) {
        incRefcount();
        var subscription = shared$.subscribe(observer);
        subscription.add(decRefcount);
        emitFirstValue();
        return subscription;
      });
      res.key = key;
      var innerGroup = {
        source: subject,
        observable: res,
        subscription: new Subscription2()
      };
      groups.set(key, innerGroup);
      innerGroup.subscription = shared$.subscribe(noop, function (e) {
        return subscriber.error(e);
      }, function () {
        groups.delete(key);
        emitFirstAdd();
        subscriber.next({
          groups: groups,
          changes: {
            type: "remove",
            keys: [key]
          }
        });
        if (groups.size === 0 && sourceCompleted) {
          subscriber.complete();
        }
      });
      emitFirstAdd();
      emitFirstValue();
    }, finalize("error"), finalize("complete"));
    return function () {
      sub2.unsubscribe();
      groups.forEach(function (g) {
        g.source.unsubscribe();
        g.subscription.unsubscribe();
      });
    };
  }).pipe(shareLatest());
  var refCount = 0;
  var sub;
  function incRefcount() {
    refCount++;
    if (refCount === 1) {
      sub = groupedObservables$.subscribe();
    }
  }
  function decRefcount() {
    refCount--;
    if (refCount === 0) {
      sub == null ? void 0 : sub.unsubscribe();
    }
  }
  return [function (key) {
    return getGroupedObservable(groupedObservables$.pipe(map2(function (_ref3) {
      var groups = _ref3.groups;
      return groups;
    })), key);
  }, groupedObservables$.pipe(map2(function (m, i) {
    if (i === 0) {
      return {
        type: "add",
        keys: m.groups.keys()
      };
    }
    return m.changes;
  }))];
}
var getGroupedObservable = function getGroupedObservable(source$, key) {
  var result = new Observable5(function (observer) {
    var innerSub;
    var outerSub;
    var foundSynchronously = false;
    outerSub = source$.subscribe(function (n) {
      var innerGroup = n.get(key);
      if (innerGroup && !innerSub) {
        innerSub = innerGroup.observable.subscribe(observer);
        outerSub == null ? void 0 : outerSub.unsubscribe();
        foundSynchronously = true;
      }
    }, function (e) {
      observer.error(e);
    }, function () {
      observer.complete();
    });
    if (foundSynchronously) {
      outerSub.unsubscribe();
      outerSub = void 0;
    }
    return function () {
      innerSub == null ? void 0 : innerSub.unsubscribe();
      outerSub == null ? void 0 : outerSub.unsubscribe();
    };
  });
  result.key = key;
  return result;
};

// src/toKeySet.ts
import { Observable as Observable6 } from "rxjs";
function toKeySet() {
  return function (source$) {
    return new Observable6(function (observer) {
      var result = /* @__PURE__ */new Set();
      var pristine = true;
      var subscription = source$.subscribe({
        next: function next(_ref4) {
          var type = _ref4.type,
            keys = _ref4.keys;
          var action = type === "add" ? type : "delete";
          var _iterator = _createForOfIteratorHelper(keys),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var k = _step.value;
              result[action](k);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          observer.next(result);
          pristine = false;
        },
        error: function error(e) {
          observer.error(e);
        },
        complete: function complete() {
          observer.complete();
        }
      });
      if (pristine) observer.next(result);
      return subscription;
    });
  };
}

// src/suspend.ts
import { from as from2 } from "rxjs";
import { SUSPENSE } from "@react-rxjs/core";

// src/internal-utils.ts
import { Observable as Observable7 } from "rxjs";
var defaultStart = function defaultStart(value) {
  return function (source$) {
    return new Observable7(function (observer) {
      var emitted = false;
      var subscription = source$.subscribe(function (x) {
        emitted = true;
        observer.next(x);
      }, function (e) {
        observer.error(e);
      }, function () {
        observer.complete();
      });
      if (!emitted) {
        observer.next(value);
      }
      return subscription;
    });
  };
};

// src/suspend.ts
var suspend = function suspend(source$) {
  return defaultStart(SUSPENSE)(from2(source$));
};

// src/suspended.ts
var suspended = function suspended() {
  return suspend;
};

// src/switchMapSuspended.ts
import { pipe } from "rxjs";
import { switchMap } from "rxjs/operators";
var switchMapSuspended = function switchMapSuspended(project) {
  return pipe(switchMap(function (x, index) {
    return suspend(project(x, index));
  }));
};

// src/selfDependent.ts
import { Subject as Subject3, BehaviorSubject } from "rxjs";
import { switchAll, tap } from "rxjs/operators";
var selfDependent = function selfDependent() {
  var activeSubject = new BehaviorSubject(new Subject3());
  return [activeSubject.pipe(switchAll()), function () {
    return tap({
      next: function next(v) {
        return activeSubject.value.next(v);
      },
      error: function error(e) {
        activeSubject.value.error(e);
        activeSubject.next(new Subject3());
      },
      complete: function complete() {
        activeSubject.value.complete();
        activeSubject.next(new Subject3());
      }
    });
  }];
};
var selfDependant = selfDependent;

// src/contextBinder.ts
import { bind } from "@react-rxjs/core";
var execSelf = function execSelf(fn) {
  return fn();
};
function contextBinder() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  var useArgs = function useArgs() {
    return args.map(execSelf);
  };
  return function () {
    var _bind$apply = bind.apply(null, arguments),
      _bind$apply2 = _slicedToArray(_bind$apply, 2),
      hook = _bind$apply2[0],
      getter = _bind$apply2[1];
    return [function () {
      for (var _len4 = arguments.length, args2 = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args2[_key4] = arguments[_key4];
      }
      return hook.apply(void 0, _toConsumableArray(useArgs()).concat(args2));
    }, getter];
  };
}

// src/createListener.ts
function createListener() {
  return createSignal.apply(void 0, arguments);
}
export { combineKeys, contextBinder, createKeyedSignal, createListener, createSignal, mergeWithKey, partitionByKey, selfDependant, selfDependent, suspend, suspended, switchMapSuspended, toKeySet };